import { useCallback, useMemo } from "react";
import { useCompanyStructureData } from "@/modules/common/entities/company-structure/select/model/use-company-structure-data";
import { HierarchyElementType } from "gql/graphql";

export function useStructureIdSplit() {
  const { nodes, loading } = useCompanyStructureData({
    types: [HierarchyElementType.Organization, HierarchyElementType.Position],
  });

  const positionIdSet = useMemo(
    () =>
      new Set(
        nodes
          .filter((element) => element.__typename === "PositionDto")
          .map((element) => element.id),
      ),
    [nodes],
  );

  const split = useCallback(
    (structureIds: string[] = []) => {
      const organizationIds: string[] = [];
      const positionIds: string[] = [];

      for (const id of structureIds) {
        if (positionIdSet.has(id)) {
          positionIds.push(id);
        } else {
          organizationIds.push(id);
        }
      }

      return { organizationIds, positionIds };
    },
    [positionIdSet],
  );

  return { split, loading };
}
